<template>
  <!-- A generic overlay with text -->
  <b-overlay v-bind="$attrs" v-on="$listeners">
    <template #overlay>
      <div class="row">
        <b-spinner></b-spinner>&nbsp;&nbsp;&nbsp;
        <span id="overlay-text">{{ text }}</span>
      </div>
    </template>
  </b-overlay>
</template>

<script>
  import { BOverlay, BSpinner } from 'bootstrap-vue'
  export default {
    props: {
      text: {
        type: String,
        required: false,
        default: ''
      }
    },

    components: {
      BOverlay,
      BSpinner
    }
  }
</script>

<style scoped>
#overlay-text {
  text-align: center;
  line-height: 1.8;
}
</style>



// WEBPACK FOOTER //
// TextOverlay.vue?1beb569a